import { FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import _ from 'lodash';

const DropDown = (props) => {

    return(
    <>
    <div className={props.className}>   
    <FormControl fullWidth>
        <InputLabel sx={{
            color: '#000000',
            marginTop: "-5px",
            fontSize: 'var(--fs-root)',
        }}
            id="demo-simple-select-label">{ props.label }</InputLabel>
        <Select
            style={{
                //width: "55vw",
                height: "2.5rem",
                marginBottom: "20px",
            }}
            value={ props.value }
            label={ props.label }
            onChange={ props.onChange }
            
            // Nedan följer tappert försök att ändra färg på linjen runt drop-downen <3 
            sx={{
                borderColor: 'primary.main',
                '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                    borderWidth: '0.15rem',
                },
                "&:after": {
                    borderBottomColor: "primary.main",
                },
                "& .MuiSvgIcon-root": {
                    color: "primary.main",
                },
                ".MuiSelect-select": {
                    color: "#000000",
                    textAlign: 'left',
                    fontSize: 'var(--fs-root)',
                },
            }}
        >
            {_.map(_.values(props.options), (option) => (
                <MenuItem sx={{ fontSize: 'var(--fs-root)' }} value={option.value}> {option.label}</MenuItem>
            ))}
 
        </Select>
    </FormControl>
    </div>
    </>
    );  
};

export default DropDown;